<template>
    <div>
        <van-popup v-model="showPopup" :style="{ width: '320px' }" bind:close="onClose">
            <div class="login-page">
                <img class="logo" src="@/assets/login/sp_logo.png" alt="">
                <div class="form">
                    <div class="form-item" :class="showCaptcha?'mt130': ''">
                        <input class="input" type="name" v-model.trim="name" placeholder="请输入姓名" >
                    </div>
                    <div class="form-item">
                        <input class="input" type="tel" v-model.trim="phone" placeholder="请输入手机号" >
                    </div>
                    <!-- <div id="captcha"></div>
                    <div class="form-item">
                        <input class="input" type="text" maxlength="6" v-model="code" placeholder="请输入验证码" >
                        <button class="btn-code" :disabled="btnDisabled" @click="getCode">{{codeBtnText}}</button>
                    </div> -->
                    <button class="btn-primary" @click="codeLogin">登录</button>
                </div>
        </div>
    </van-popup>
    </div>
</template>

<script>
import validate from '@/common/validate.js'
import {SendMobileCode, autoExamEngineerLogin} from '@/common/api.js'

export default {
    data() {
        return {
            showPopup: false,
            name:'',
            phone: '',
            code: '',
            codeBtnText:'获取验证码',
            showCaptcha: false
        }
    },
    mounted() {

    },
    methods: {
        onShow() {
            this.showPopup  = true;
        },
        onClose() {
            this.showPopup  = false;
        },
        //获取验证码
    getCode(){
      let that = this
      if(this.phone.trim()===''){
        this.$notify('请输入手机号！');
        return;
      }
      if(this.phone.trim()!=='' && !validate.phone(this.phone)){
        this.$notify('手机号格式不正确');
        return;
      }
      this.showCaptcha  = true;
      var myCaptcha = _dx.Captcha(document.getElementById('captcha'), {
          appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
          style: 'inline',
          success: function (token) {
            this.showCaptcha = false;
            SendMobileCode({
              phone: that.phone,
              codeType: 112,
              imgCodeToken:token,
            }).then(r => {
              // myCaptcha.hide();
              if (r.Result == 1) {
                let time = 120;
                that.btnDisabled = true;
                that.timer = setInterval(() => {
                  time--;
                  that.codeBtnText = time + "s";
                  if (time <= 0) {
                    time = 120;
                    that.btnDisabled = false;
                    that.codeBtnText = "获取验证码";
                    clearInterval(that.timer);
                  }
                }, 1000);
                that.$toast(r.Message);
              } else {
                that.$toast(r.Message);
              }
            });
          },
          fail:function(err){
            this.showCaptcha = false;
            console.log(err)
          }
      })
      myCaptcha.show();
    },
    //验证码登录
    codeLogin(){
      if(this.name.trim()===''){
        this.$notify('请输入姓名！');
        return;
      }
      if(this.phone.trim()===''){
        this.$notify('请输入手机号！');
        return;
      }
      if(this.phone.trim()!=='' && !validate.phone(this.phone)){
        this.$notify('手机号格式不正确');
        return;
      }
      // if(this.code.trim()===''){
      //   this.$notify('请输入验证码！');
      //   return;
      // }
      autoExamEngineerLogin({
        UserName: this.name,
        Handset: this.phone,
        "appKey": '1',
        "Sign": '1',
        "platform": 'pcweb'
        // ValidateCode: this.code,
        // AppId: 101001,
      }).then(r=>{
        if(r.Result == 1) {
          this.$notify({ type: 'success', message: '登录成功! ' });
          this.$setStorage('engineerRExamUserId',r.Data.UserId);
          this.$setStorage('engineerRExamUserInfo',r.Data);
          setTimeout(() => {
            this.onClose()
            this.$emit('success')
          }, 500);
        }else{
          this.$notify(r.Message);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page{
  .logo {
    margin: 20px auto 0 auto;
    display: block;
    width: 120px;
  }
  .form{
    width: 80%;
    margin: 0 auto;
  }
  .form-item{
    width: 100%;
    position: relative;
    height: 44px;
    margin-top: 20px;
  }
  .input{
    display: block;
    width: 100%;
    height: 44px;
    padding: 10px;
    line-height: 24px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #e5e5e5;
    &:focus{
      border-color: #F75959;
    }
  }
  .btn-code{
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #d5d5d5;
    color: #333;
    font-size: 14px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    border-radius: 30px;
    margin-top: 6px;
  }
  .btn-text{
    font-size: 14px;
    color: #F75959;
    line-height: 24px;
    margin-top: 10px;
  }
  .btn-text-white{
    font-size: 14px;
    color: #333;
    line-height: 24px;
    margin-top: 10px;
  }
  .btn-primary{
    display: block;
    height: 44px;
    width: 100%;
    font-size: 16px;
    background-color: #fff;
    color: #f75959;
    border: 1px solid #f75959;
    border-radius: 45px;
    margin: 20px 0;
  }
}
  </style>